import { useI18nLang } from '@/core/app';

/**
 * Вспомогательный класс для работы с разными Поисковиками
 */
export const searchersNames = {
	0: 'Yandex',
	20: 'Yandex.com',
	21: 'Yandex.com.tr',
	1: 'Google',
	4: 'YouTube',
	5: 'Bing',
	7: 'Seznam',
	8: 'AppStore',
	9: 'GooglePlay',
	101: 'VK',
	102: 'Facebook',
	103: 'Twitter',
};

/**
 * Получить иконку ПС
 * @param searcherKey - цифра или строка с цифрой обозначающая ПС. Если null вернется иконка с глобусом
 */
export const getSearcherGIcon = (searcherKey: number | string | undefined): string => {
	let icon = '';

	if (typeof searcherKey === 'string') searcherKey = Number(searcherKey);

	switch (searcherKey) {
		case 0:
			icon = '';

			break;
		case 20:
		case 21:
			icon = '';

			break;
		case 1:
			icon = '';

			break;
		case 2:
			icon = '';

			break;
		case 3:
			icon = '';

			break;
		case 4:
			icon = '';

			break;
		case 5:
			icon = '';

			break;
		case 6:
			icon = '';

			break;
		case 7:
			icon = '';

			break;
		case 8:
			icon = '';

			break;
		case 9:
			icon = '';

			break;
		case null:
			icon = '';

			break;
	}

	return icon;
};

/**
 * Получить иконку устройства (ПК, планшет, смартфон)
 */
export const getDeviceGIcon = (device: number | string): string => {
	let icon = '';

	if (typeof device === 'string') device = Number(device);

	switch (device % 10) {
		case 0:
			icon = '';

			break;
		case 1:
			icon = '';

			break;
		case 2:
			icon = '';

			break;
	}

	return icon;
};

/**
 * Получить иконку языка
 */
export const getLangLabel = (searcherKey: number | string, lang: string) => {
	if (typeof searcherKey === 'string') searcherKey = Number(searcherKey);

	switch (searcherKey * 1) {
		case 1:
		case 4:
		case 5:
		case 6:
		case 8:
		case 9:
			return lang;
	}

	return '';
};

/**
 * Сгенерировать заголовок типа частоты
 */
export const genVolumeLabel = (label: string, searcherKey: 0 | 1, volumeType: 1 | 2 | 3 | 5 | 6): string => {
	switch (searcherKey * 1) {
		// Яндекс
		case 0:
			switch (volumeType * 1) {
				case 2:
					label = `"${label}"`;

					break;
				case 3:
					label = `"!${label}"`;

					break;
				case 5:
					label = `"[${label}]"`;

					break;
				case 6:
					label = `"[!${label}]"`;

					break;
			}
			break;
		// Google
		case 1:
			label = `[${label}]`;

			break;
	}

	return label;
};

/**
 * Проверить значение частоты, вернуть правильное значение частоты
 */
export const prepareVolumeType = (searcherKey: number, volumeType: number): number => {
	// по умолчанию выбрана сама точная частота
	if (volumeType === null) volumeType = 6;

	switch (searcherKey) {
		case 1:
			volumeType = 3;

			break;
		case 2:
			volumeType = 2;

			break;
		case 5:
			if (volumeType > 1) volumeType = 1;

			break;
		default:
			if (![1, 2, 3, 5, 6].includes(volumeType)) volumeType = 3;
	}

	return volumeType;
};
